import { jsxs as d, jsx as l } from "react/jsx-runtime";
import p from "clsx";
const m = (o) => p(o), e = "dds-label-v0162";
function _({
  as: o,
  children: n,
  className: i = "",
  htmlFor: s,
  optional: a = !1,
  required: t = !1,
  ...r
}) {
  const c = {
    [e]: !0,
    [i]: i.length > 0
  };
  return /* @__PURE__ */ d(o || "label", { htmlFor: s, className: m(c), ...r, children: [
    n,
    t ? /* @__PURE__ */ l("abbr", { className: `${e}__required-indicator`, title: "This field is required", children: "*" }) : "",
    !t && a ? /* @__PURE__ */ l("span", { className: `${e}__optional-indicator`, title: "This field is optional", children: "(optional)" }) : ""
  ] });
}
export {
  _ as Label
};
//# sourceMappingURL=index.js.map
